export const rechargeCols = [
  {
    title: '新建日期',
    key: 'date'
  },
  {
    title: '充值状态',
    key: 'rechargeStatus'
  },
  {
    title: '账户ID',
    key: 'toAccountId'
  },
  {
    title: '媒体',
    key: 'mediaName'
  },

  {
    title: '账户名称',
    key: 'accountName'
  },
  {
    title: '计划主ID',
    key: 'advertiserId'
  },
  {
    title: '账面充值金额',
    key: 'orderPaperUserAmount'
  },
  {
    title: '返点',
    key: 'rebate'
  },
  {
    title: '实际充值金额',
    key: 'orderAmount'
  },
  {
    title: '新建人',
    key: 'createOpName'
  }
]

export const transferCols = [
  {
    title: '新建日期',
    key: 'date'
  },
  {
    title: '转账状态',
    key: 'transferStatus'
  },
  {
    title: '媒体（转出）',
    key: 'mediaName'
  },
  {
    title: '转出账户',
    key: 'fromAccountName'
  },
  {
    title: '计划主ID（转出）',
    key: 'fromAdvertiserId'
  },
  {
    title: '转账资金类型',
    key: 'mediaTransferDesc'
  },
  {
    title: '转账方式',
    key: 'transferType'
  },
  {
    title: '转入账号',
    key: 'toAccountName'
  },
  {
    title: '计划主ID（转入）',
    key: 'toAdvertiserId'
  },
  {
    title: '账面转账金额',
    key: 'orderPaperUserAmount'
  },
  {
    title: '返点',
    key: 'toRebate'
  },
  {
    title: '实际转账金额',
    key: 'orderAmount'
  },
  {
    title: '新建人员',
    key: 'createOpName'
  }
]
